import React, { useState, useEffect } from "react";
import { Phone, Mail } from "lucide-react";
import Loading from "../../component/Loading/Loading";
import useAxiosInstance from "../../services/useAxiosInstance";

const Vendor = () => {
    const axiosInstance = useAxiosInstance();
    const [vendors, setVendors] = useState([]);
    const [accessCode, setAccessCode] = useState("");
    const [filteredVendors, setFilteredVendors] = useState([]);
    const [serviceRequestId, setServiceRequestId] = useState(null);
    const [assignedVendors, setAssignedVendors] = useState([]);
    const [isValid, setIsValid] = useState(true);
    const [isAccessCodeValid, setIsAccessCodeValid] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleAccessCodeChange = (e) => {
        setAccessCode(e.target.value);
        setIsValid(true);
        setIsAccessCodeValid(false);
    };

    const handleAccessCodeSubmit = () => {
        if (!accessCode) {
            setIsValid(false);
            return;
        }
        console.log("Access Code Submitted:", accessCode);
        const filtered = vendors.filter((vendor) =>
            vendor.zipCode.toString().includes(accessCode)
        );
        setFilteredVendors(filtered);
    };

    useEffect(() => {
        if (accessCode) {
            const fetchServiceRequestByAccessCode = async () => {
                setLoading(true);
                try {
                    const response = await axiosInstance.get(`/api/public/servicerequest/getServiceRequestByVendorAccessCode/${accessCode}`);
                    console.log("Service Request Response:", response.data);
                    setServiceRequestId(response.data.serviceRequestId);
                    setIsAccessCodeValid(true);

                } catch (error) {
                    console.error("Error fetching service request by access code:", error);
                    setIsAccessCodeValid(false);
                } setLoading(false);
            };

            fetchServiceRequestByAccessCode();
        }
    }, [accessCode]);

    useEffect(() => {
        if (serviceRequestId) {
            const fetchAssignedVendors = async () => {
                setLoading(true);
                console.log(serviceRequestId);

                try {
                    const response = await axiosInstance.get(`/api/public/assignedVendors/assignedVendors/${serviceRequestId}`);
                    console.log("Assigned Vendors Response:", response.data);
                    setAssignedVendors(response.data);
                } catch (error) {
                    console.error("Error fetching assigned vendors:", error);
                } setLoading(false);
            };

            fetchAssignedVendors();
        }
    }, [serviceRequestId]);

    return (
        <div className="bg-gray-50 min-h-screen md:p-4">
            {loading && <Loading />}
            {!loading && (
                <div className="max-w-7xl mx-auto">
                    <div className="flex justify-between items-center mb-6">
                        <h1 className="text-2xl font-bold text-gray-800">Vendor</h1>
                    </div>

                    <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
                        <div className="p-4 border-b border-gray-200">
                            <div className="flex flex-wrap md:flex-nowrap justify-end items-center gap-2">
                                <input
                                    type="text"
                                    id="accessCode"
                                    placeholder="Enter Vendor access code"
                                    value={accessCode}
                                    onChange={handleAccessCodeChange}
                                    className={`w-full md:w-auto rounded-md border ${isValid ? "border-gray-300 focus:ring-2 focus:ring-blue-500" : "border-red-500"} px-4 py-2 focus:outline-none`}
                                />
                                <button
                                    className="w-full md:w-auto bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md"
                                    onClick={handleAccessCodeSubmit}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>

                        <div className="overflow-x-auto">
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-blue-400">
                                    <tr>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Company Name</th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Vendor Name</th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Business Phone</th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Business EmailId</th>
                                        <th className="px-6 py-3 text-center text-sm font-medium text-white tracking-wider">Contact</th>
                                    </tr>
                                </thead>
                                {assignedVendors && (
                                    <tbody className="bg-white divide-y divide-gray-200">
                                        {assignedVendors.length === 0 ? (
                                            <tr>
                                                <td colSpan="5" className="px-6 py-4 text-center text-sm text-gray-500">No Data Found</td>
                                            </tr>
                                        ) : (
                                            assignedVendors.map((vendor) => (
                                                <tr key={vendor.assignedVendorId} className="hover:bg-gray-50">
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{vendor.companyName}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{vendor.vendorName}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{vendor.businessPhone}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{vendor.businessEmailId}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm flex justify-center gap-3">
                                                        <a
                                                            href={`mailto:${vendor.businessEmailId}`}
                                                            className="text-blue-500 hover:text-blue-700"
                                                            title="Send Email"
                                                        >
                                                            <Mail size={18} />
                                                        </a>
                                                        <a
                                                            href={`tel:${vendor.businessPhone}`}
                                                            className="text-blue-500 hover:text-blue-700"
                                                            title="Call Vendor"
                                                        >
                                                            <Phone size={18} />
                                                        </a>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                )}
                            </table>
                        </div>

                        <div className="bg-gray-50 px-6 py-3 border-t border-gray-200">
                            <div className="text-sm text-gray-700">
                                {assignedVendors && (
                                    <>Showing {assignedVendors.length} {assignedVendors.length === 1 ? 'vendor' : 'vendors'}</>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
export default Vendor;